module.exports = __webpack_public_path__ + "img/symbol_2.dce57e33.png";